import { fetchResource } from "../helpers/network";

import { setErrorNotification } from "../actions/notifications";

export const REQUEST_JOBS = "REQUEST_JOBS";
export const RECEIVE_JOBS = "RECEIVE_JOBS";
export const REQUEST_JOB = "REQUEST_JOB";

export const requestJobs = () => ({
  type: REQUEST_JOBS
});

export const requestJob = () => ({
  type: REQUEST_JOB
});

export const receiveJobs = json => ({
  /* coerce to array */
  type: RECEIVE_JOBS,
  jobs: Array.isArray(json.data) ? json.data : json.data ? [json.data] : []
});

export function fetchJobs(params) {
  const paramsWithPath = Object.assign({}, params, { path: "/jobs" });
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        requestJobs,
        receiveJobs,
        setErrorNotification
      )
    );
  };
}

export function fetchJob(id, params) {
  const paramsWithPath = Object.assign({}, params, { path: `/jobs/${id}` });
  return function(dispatch, getState) {
    return dispatch(
      fetchResource(
        paramsWithPath,
        requestJob,
        receiveJobs,
        setErrorNotification
      )
    );
  };
}



// WEBPACK FOOTER //
// ./src/actions/jobs.js